import _ from "lodash";
import { isSentralPortalFeatureEnabled } from "Utils/ACLStoreUtils";
import {
  ENABLE_SENTRAL_PORTAL_WELLBEING_BUTTON,
  ENABLE_SENTRAL_PORTAL_ATTENDANCE_BUTTON,
  ENABLE_SENTRAL_PORTAL_POLICIES_AND_RESOURCES_BUTTON,
  ENABLE_SENTRAL_PORTAL_TIMETABLE_BUTTON,
  ENABLE_SENTRAL_PORTAL_STUDENT_PROFILE_BUTTON,
  ENABLE_SENTRAL_PORTAL_DASHBOARD_BUTTON,
  ENABLE_SENTRAL_NEWSFEED_BUTTON,
  ENABLE_SENTRAL_NOTICE_BUTTON,
  ENABLE_SENTRAL_DOCUMENTS_BUTTON,
  ENABLE_SENTRAL_PXP_BUTTON,
  ENABLE_SENTRAL_QUEST_WEEK_BUTTON,
  ENABLE_SENTRAL_SPORTS_BUTTON,
  ENABLE_SENTRAL_PORTAL_ACTIVITY_BUTTON,
} from "Constants/permissionConstants";
import {
  getIsSentralLoginActivityLogged,
  setIsSentralLoginActivityLogged,
} from "services/localStorage";
import { closeSentralPortalIframe } from "Login/modules/LoginModule/LoginUtils";

export const SENTRAL_PERMISSION_CONFIGURATIONS = {
  WELLBEING: ENABLE_SENTRAL_PORTAL_WELLBEING_BUTTON,
  ATTENDANCE: ENABLE_SENTRAL_PORTAL_ATTENDANCE_BUTTON,
  POLICIES_AND_RESOURCES: ENABLE_SENTRAL_PORTAL_POLICIES_AND_RESOURCES_BUTTON,
  TIMETABLE: ENABLE_SENTRAL_PORTAL_TIMETABLE_BUTTON,
  STUDENT_PROFILE: ENABLE_SENTRAL_PORTAL_STUDENT_PROFILE_BUTTON,
  DASHBOARD: ENABLE_SENTRAL_PORTAL_DASHBOARD_BUTTON,
  NEWSFEED: ENABLE_SENTRAL_NEWSFEED_BUTTON,
  NOTICE: ENABLE_SENTRAL_NOTICE_BUTTON,
  DOCUMENTS: ENABLE_SENTRAL_DOCUMENTS_BUTTON,
  PXP: ENABLE_SENTRAL_PXP_BUTTON,
  QUEST_WEEK: ENABLE_SENTRAL_QUEST_WEEK_BUTTON,
  SPORTS: ENABLE_SENTRAL_SPORTS_BUTTON,
  ACTIVITIES: ENABLE_SENTRAL_PORTAL_ACTIVITY_BUTTON,
};

export const isInIframe = () => {
  return window.self !== window.top;
};

export const isOverviewContext = () => {
  return _.includes(window.location.href, "/overview");
};

/**
 * Checks if Sentral configuration is enabled
 * based on permissions for Module Settings.
 */
export const isSentralConfigurationEnabled = (
  label,
  curriculumProgramAcronym
) => {
  // Allow KJS and BS schools to control school policies and resources independently in module settings,
  // bypassing the Sentral Policies and Resources widget permission check
  if (
    label === "school_policies_and_resources" &&
    _.includes(["KJS", "BS"], curriculumProgramAcronym)
  ) {
    return false;
  }
  const SENTRAL_LABEL_MAPPING = {
    attendance: SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
    timetable: SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    school_policies_and_resources:
      SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES,
    behaviour: SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
  };

  const permission = SENTRAL_LABEL_MAPPING[label];
  return permission ? isSentralPortalFeatureEnabled(permission) : false;
};

export const storeStudentNavigationForSentral = ({
  currentUrl,
  studentProfileUrl,
}) => {
  const sentralActivity = getIsSentralLoginActivityLogged();
  setIsSentralLoginActivityLogged({
    ...sentralActivity,
    backUrl: currentUrl,
    studentProfileUrl,
    firstTimeLogin: true,
  });
};

export const checkIsSentralFeatureEnabledInCurriculum = (
  feature,
  curriculumConfigMap,
  curriculumProgramId
) => {
  const isSentralFeatureEnabled =
    _.get(curriculumConfigMap, [curriculumProgramId, feature, "value"]) ===
    "true";

  return isSentralFeatureEnabled;
};

export const checkIsSentralFeatureEnabledInCurriculums = (
  feature,
  curriculumConfigMap,
  curriculumProgramIds
) => {
  const isSentralFeatureEnabled = _.some(
    curriculumProgramIds,
    curriculumProgramId =>
      _.get(curriculumConfigMap, [curriculumProgramId, feature, "value"]) ===
      "true"
  );

  return isSentralFeatureEnabled;
};

export const storeStudentNavigationState = () => {
  closeSentralPortalIframe();
  const sentralActivity = getIsSentralLoginActivityLogged();
  setIsSentralLoginActivityLogged({
    ...sentralActivity,
    firstTimeLogin: true,
  });
};

export const handleSentralBackNavigation = (
  goToRelativeRoute,
  goBackToPlatform
) => {
  closeSentralPortalIframe();
  const sentralActivity = getIsSentralLoginActivityLogged();
  if (sentralActivity.backUrl) {
    goToRelativeRoute({
      route: sentralActivity.backUrl,
    });
  } else {
    goBackToPlatform();
  }
};
